<template>
  <router-view />
  <notification-watcher />
</template>

<script>
import { mapState, mapActions, mapWritableState } from 'pinia'
import { useHolofuelStore, useHoloStore, useHhaStore, useNotificationStore, useHappStatsStore, useHbsStore } from 'src/stores'
import NotificationWatcher from 'src/components/NotificationWatcher.vue'

const LOAD_INVOICES_INTERVAL = 60_000

export default {
  name: 'App',
  components: {
    NotificationWatcher
  },
  data () {
    return {
      loadInvoicesInterval: null
    }
  },
  async mounted() {
    try {
      await this.initialize()
      await this.initializeNotificationStore()
      if (this.isAnonymous) {
        this.openAuthForm()
      }
    } catch (e) {
      console.error('Holo store init error', e)
    }
  },
  methods: {
    ...mapActions(useHolofuelStore, ['loadMyNickname','loadLedger', 'loadInvoices']),
    ...mapActions(useHhaStore, ['loadHapps', 'fetchHoloportPricingAndJurisdictions']),
    ...mapActions(useHoloStore, ['initialize', 'signIn', 'signUp', 'signOut']),
    ...mapActions(useHbsStore, ['loadAgentKycLevel', 'loadJurisdictions']),
    ...mapActions(useNotificationStore, { initializeNotificationStore: 'initialize'}),
    ...mapActions(useHappStatsStore, ['loadDashboardStats']),

    openAuthForm () {
      if (this.$route.path == '/signup') {
        this.signUp()
      } else {
        this.signIn()
      }
    }
  },
  computed: {
    ...mapWritableState(useHoloStore, ['isAuthFormOpen']),
    ...mapState(useHoloStore, ['isAnonymous', 'isLoggedIn']),
  },
  watch: {
    async isLoggedIn(is_logged_in) {
      if (is_logged_in) {
        this.isAuthFormOpen = false
        await Promise.all([
          this.loadHapps(),
          this.fetchHoloportPricingAndJurisdictions(process.env.VUE_APP_ENV, process.env.VUE_APP_HBS_SERVICE_PORT)
        ])
        this.loadMyNickname()
        this.loadLedger()
        this.$router.push(this.$route.params.nextUrl || '/dashboard')
        this.loadInvoices()
        this.loadInvoicesInterval = setInterval(() => this.loadInvoices(), LOAD_INVOICES_INTERVAL)

        this.loadAgentKycLevel(process.env.VUE_APP_ENV, process.env.VUE_APP_HBS_SERVICE_PORT)
        this.loadJurisdictions(process.env.VUE_APP_ENV, process.env.VUE_APP_HBS_SERVICE_PORT)
        this.loadDashboardStats(7, process.env.VUE_APP_ENV, process.env.VUE_APP_HBS_SERVICE_PORT)
      } else {
        clearInterval(this.loadInvoicesInterval)
        this.loadInvoicesInterval = null
      }
    },
    isAnonymous(is_anonymous) {
      if (is_anonymous && !this.isAuthFormOpen) {
        this.openAuthForm()
      }
    },
  },
}
</script>

<style>
@import '../ui-common-library/artifacts/styles/common.css';
@import './common.css';

html {
  overflow-y: scroll;
}
body,
html {
  height: 100%;
}
#app {
  font-family: var(--font-family);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #fafcfe;
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
